// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__qJpys","icon":"SearchBar_icon__YRFWO","input":"SearchBar_input__+8uKK"};